module.exports = __webpack_public_path__ + "3698847c16f78e4ca8740d3ac03dd42b.png";